// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".saxR-asM-V6PIUqOeiKv4g\\=\\= {\n  padding-left: 38px;\n}\n.ygbTZBPNrXT2MmBEML8ymA\\=\\= {\n  padding-top: 10px;\n}\n", "",{"version":3,"sources":["webpack://./src/notifications/styles/NotificationSettings.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB","sourcesContent":[".optionTitle {\n  padding-left: 38px;\n}\n.optionContainer {\n  padding-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"optionTitle": "saxR-asM-V6PIUqOeiKv4g==",
	"optionContainer": "ygbTZBPNrXT2MmBEML8ymA=="
};
export default ___CSS_LOADER_EXPORT___;
